import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "case-studies-page" }
const _hoisted_2 = { class: "case-studies-grid" }
const _hoisted_3 = { class: "cta-section mt-12 text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CaseStudyCard = _resolveComponent("CaseStudyCard")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[4] || (_cache[4] = _createElementVNode("div", { class: "hero-section mb-12" }, [
      _createElementVNode("div", { class: "hero-content text-center" }, [
        _createElementVNode("h1", { class: "hero-title mb-6" }, " Real-World Stories of Building Humane AI "),
        _createElementVNode("p", { class: "hero-subtitle mx-auto" }, " Discover how organizations are implementing humane AI principles in production. These case studies showcase practical approaches to measuring and improving AI humaneness at scale. ")
      ])
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.caseStudies, (caseStudy, index) => {
        return (_openBlock(), _createBlock(_component_CaseStudyCard, {
          key: index,
          "case-study": caseStudy,
          class: "mb-6"
        }, null, 8, ["case-study"]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_v_card, {
        class: "pa-8 rounded-lg",
        color: "#f8f4eb"
      }, {
        default: _withCtx(() => [
          _cache[2] || (_cache[2] = _createElementVNode("h3", { class: "cta-title mb-4" }, "Have a story to share?", -1)),
          _cache[3] || (_cache[3] = _createElementVNode("p", {
            class: "text-grey-darken-2 mb-6 mx-auto",
            style: {"max-width":"500px"}
          }, " If you've implemented HumaneBench or humane AI practices in your organization, we'd love to feature your experience. ", -1)),
          _createVNode(_component_v_btn, {
            color: "black",
            class: "text-white text-none",
            rounded: "lg",
            href: "mailto:info@buildinghumanetech.com?subject=Case Study Submission"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, {
                left: "",
                size: "18",
                class: "mr-2"
              }, {
                default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                  _createTextVNode("mdi-email-outline", -1)
                ]))]),
                _: 1
              }),
              _cache[1] || (_cache[1] = _createTextVNode(" Get in touch ", -1))
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ])
  ]))
}